import React, { useState, useRef, useEffect } from 'react';
import { BsFilter } from 'react-icons/bs';

const ColumnFilter = ({
    headers,
    onFilterChange,
    activeFilters = {},
    className = ''
}) => {
    const [showFilterDropdown, setShowFilterDropdown] = useState(false);
    const filterDropdownRef = useRef(null);
    const buttonRef = useRef(null);

    // Handle click outside to close dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (filterDropdownRef.current && !filterDropdownRef.current.contains(event.target)) {
                setShowFilterDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleFilterChange = (headerKey, value) => {
        if (onFilterChange) {
            const newFilters = { ...activeFilters };
            if (value) {
                newFilters[headerKey] = value;
            } else {
                delete newFilters[headerKey];
            }
            onFilterChange(newFilters);
        }
    };

    // Get unique values for each column
    const getColumnValues = (headerKey) => {
        const header = headers.find(h => h.key === headerKey && h.filterable);
        if (!header) return [];

        // Return the filterOptions from the header configuration
        return header.filterOptions || [];
    };

    // Only show filterable columns
    const filterableHeaders = headers.filter(header => header.filterable);

    if (filterableHeaders.length === 0) {
        return null;
    }

    return (
        <div className="relative" ref={filterDropdownRef}>
            <button
                ref={buttonRef}
                onClick={() => setShowFilterDropdown(!showFilterDropdown)}
                className={`inline-flex items-center h-8 px-1 py-1 focus:outline-none rounded-md border focus:ring-1 focus:ring-gray-300 ${Object.keys(activeFilters).length > 0 ? 'bg-blue-50' : ''} ${className}`}
            >
                <BsFilter className="h-4 w-4 lg:mr-1.5" />
                <span className="hidden lg:inline text-xs">
                    {filterableHeaders.find(h => h.filterLabel)?.filterLabel || 'Column Filter'}
                </span>
                {Object.keys(activeFilters).length > 0 && (
                    <span className="ml-1.5 bg-blue-100 text-blue-800 text-xs font-medium px-1.5 py-0.5 rounded-full">
                        {Object.keys(activeFilters).length}
                    </span>
                )}
            </button>

            {showFilterDropdown && (
                <div 
                    className="absolute left-0 mt-1 w-full rounded-lg shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50 overflow-hidden"
                    style={{ minWidth: buttonRef.current?.offsetWidth }}
                >
                    <div className="py-1 max-h-[60vh] overflow-y-auto" role="menu">
                        {filterableHeaders.map((header) => (
                            <div key={header.key} className="px-3 py-2 border-b last:border-b-0">
                                <div className="font-medium text-sm text-gray-700 mb-1">
                                    {header.label}
                                </div>
                                <select
                                    value={activeFilters[header.key] || ''}
                                    onChange={(e) => handleFilterChange(header.key, e.target.value)}
                                    className="w-full text-sm border rounded px-2 py-1 focus:outline-none focus:ring-1 focus:ring-blue-500"
                                >
                                    <option value="">All</option>
                                    {getColumnValues(header.key).map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ColumnFilter; 